import React from "react";

const Page404 = () => {
  return <div>Errore 404</div>;
};

export default Page404;
